import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import cx from 'classnames'

import './style.scss'

export default class BisnodeCertificates extends Component {
    static propTypes = {
        certificates: PropTypes.array,
        country: PropTypes.string,
    }

    renderCertificateContent = () => {
        const {
            certificates,
            translates: { certificateCodeTranslates },
        } = this.props

        return (
            <div className={cx('certificates-content')}>
                {certificates.map((certficicate, index) => (
                    <div key={`certificate-${index}`} className={cx('certificate')}>
                        <Tooltip
                            key={`certificate-${index}`}
                            id={`certificate-id-${index}`}
                            content={certificateCodeTranslates[certficicate?.code]}
                            position={POSITION.TOP}
                            align={ALIGN.CENTER}
                        >
                            <div className={cx('certificate-img', certficicate?.code)} />
                        </Tooltip>
                        <div className={cx('certificate-text')}>{certficicate?.description ?? ''}</div>
                    </div>
                ))}
            </div>
        )
    }

    renderCertificateFooter = () => {
        const {
            translates: { footer },
        } = this.props

        return <div className={cx('certificates-footer')}>{footer}</div>
    }

    render() {
        const {
            translates: { title },
            country,
        } = this.props

        return (
            <div className={cx('bisnode-certificates')}>
                <div className={cx('certificates-title')}>{title}</div>

                {this.renderCertificateContent()}
                {(country === 'CZ' || country === 'SK') && this.renderCertificateFooter()}
            </div>
        )
    }
}
